/*
 * The wrapping ol and list li is baked into
 * Algolia widget. Adjust the classes on those in
 * SolutionsSearchResults.js
 * See: https://www.algolia.com/doc/api-reference/widgets/infinite-hits/js/#widget-param-cssclasses
 */
export const solutionsHitTpl = `
  <a href="{{ url }}" class="flex h-full xs:block p-6 bg-white hover:bg-blue transition duration-200 group relative items-start rounded border-gray-300 border-2 hover:border-blue">
    <figure class="w-20 h-20 xs:mb-5 flex-none mr-5 xs:mr-0 bg-white rounded-full border-2 border-gray-300 mt-0 xs:-mt-15 flex items-center">
      <img src="{{ icon }}" alt="{{ title }} Icon" class="mx-auto max-w-full" />
    </figure>
    <div class="">
        <h3 class="hd text-blue group-hover:text-white text-lg leading-tight mb-1.5 transition duration-200">
          {{ title }}
        </h3>
        <span class="block text-sm leading-snug text-gray-700 group-hover:text-white transition duration-200 line-clamp-5">
            {{ summary }}
        </span>
    </div>
  </a>
`;
